var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"true-false"}},[_c('div',{staticClass:"true-false-container"},_vm._l((_vm.baseQuestions),function(base,index){return _c('b-form-radio',{key:index,class:{
            'incorrect': base.id === _vm.userAnswer && !base.isCorrect,
            'correct': base.id === _vm.userAnswer && base.isCorrect
        },attrs:{"value":base.id,"checked":_vm.userAnswer,"disabled":""}},[_c('span',{domProps:{"innerHTML":_vm._s(base.text)}})])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }